import React, { useCallback } from 'react'
import { getToday } from 'utils'
import { getFormFormattedDate } from 'utils-next/dates'
import { FieldProps } from 'utils-next/forms'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { FormControlLabel, Switch } from '@mui/material'

export type IsCurrentRoundSwitchProps = ExtendableStyles &
  Testable &
  FieldProps & {
    label?: React.ReactNode
  }

export function IsCurrentRoundSwitch({
  className,
  style,
  field,
  label,
  form: { setFieldValue, values },
  ...corporateSwitchProps
}: IsCurrentRoundSwitchProps) {
  const isCurrent = !values.announcedOn
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.checked) {
        setFieldValue('announcedOn', '')
        setFieldValue('roundSize', '')
      } else {
        setFieldValue('announcedOn', getFormFormattedDate(getToday()))
        setFieldValue('roundSize', '')
      }
    },
    [isCurrent, setFieldValue]
  )

  return (
    <FormControlLabel
      control={<Switch checked={isCurrent} onChange={handleChange} {...corporateSwitchProps} />}
      label={label}
      className={className}
      style={style}
    />
  )
}
